var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list-item",
    {
      class:
        (_vm.containerNoMargin ? "ma-0" : "mb-4") +
        (_vm.containerNoPadding ? " pa-0" : ""),
    },
    [
      _vm.currentBreakpoint > 1 &&
      (!_vm.isNoWs(_vm.prependImage) || !_vm.isNoWs(_vm.prependIcon))
        ? _c(
            "v-list-item-avatar",
            { staticClass: "ma-0 mr-4 row-height align-center" },
            [
              !_vm.isNoWs(_vm.prependImage)
                ? _c("v-img", {
                    attrs: {
                      src: _vm.course.additionalDetails.CourseLeaderPortrait,
                    },
                  })
                : !_vm.isNoWs(_vm.prependIcon)
                ? _c("v-icon", [_vm._v(" " + _vm._s(_vm.prependIcon) + " ")])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._t("content-override", function () {
        return [
          _c(
            "v-list-item-content",
            {
              class:
                "align-center row-height" +
                (_vm.expandable
                  ? " overflow-visible pa-0"
                  : " elevation-2 pa-2 rounded"),
            },
            [
              !_vm.expandable
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        position: "relative",
                        "max-width": "100%",
                      },
                    },
                    [
                      _vm._t("header", function () {
                        return [
                          _c(
                            "v-list-item-title",
                            { staticStyle: { "text-wrap": "balance" } },
                            [
                              _c("div", {
                                domProps: { innerHTML: _vm._s(_vm.title) },
                              }),
                            ]
                          ),
                          _c(
                            "v-list-item-subtitle",
                            {
                              staticStyle: {
                                "text-wrap": "balance",
                                "white-space": "pre-line",
                              },
                            },
                            [
                              _c("div", {
                                domProps: { innerHTML: _vm._s(_vm.subTitle) },
                              }),
                            ]
                          ),
                        ]
                      }),
                    ],
                    2
                  )
                : _c(
                    "div",
                    [
                      _c(
                        "v-expansion-panels",
                        {
                          attrs: {
                            accordion: "",
                            mandatory: _vm.expansionStayOpen,
                          },
                        },
                        [
                          _c(
                            "v-expansion-panel",
                            { staticClass: "pa-2" },
                            [
                              _c(
                                "v-expansion-panel-header",
                                {
                                  staticClass: "pa-0",
                                  attrs: {
                                    "expand-icon": _vm.expansionStayOpen
                                      ? ""
                                      : "mdi-menu-down",
                                  },
                                },
                                [
                                  _vm._t("expansion-header", function () {
                                    return [
                                      _vm._v(" " + _vm._s(_vm.title) + " "),
                                    ]
                                  }),
                                ],
                                2
                              ),
                              _c(
                                "v-expansion-panel-content",
                                {
                                  staticClass: "pa-0",
                                  style:
                                    "max-height: " +
                                    _vm.expansionContentMaxHeight +
                                    "; overflow-y: auto; overflow-x: hidden",
                                },
                                [
                                  _c(
                                    "v-list",
                                    { attrs: { subheader: "" } },
                                    [
                                      !_vm.isNoWs(_vm.subTitle)
                                        ? _c(
                                            "v-subheader",
                                            { attrs: { inset: "" } },
                                            [_vm._v(_vm._s(_vm.subTitle))]
                                          )
                                        : _vm._e(),
                                      _vm._t("expansion-content"),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ]
          ),
        ]
      }),
      !_vm.isNoWs(_vm.appendIcon)
        ? _c(
            "v-list-item-action",
            {
              staticClass:
                "align-center row-height elevation-2 pa-2 ma-0 ml-4 rounded row-height",
            },
            [
              _vm._t("actionarea", function () {
                return [
                  !_vm.isNoWs(_vm.appendIconTooltip)
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: _vm.handleActionIconClick,
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("v-icon", [
                                          _vm._v(
                                            " " + _vm._s(_vm.appendIcon) + " "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            108404372
                          ),
                        },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.appendIconTooltip),
                            },
                          }),
                        ]
                      )
                    : _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: { click: _vm.handleActionIconClick },
                        },
                        [
                          _c("v-icon", [
                            _vm._v(" " + _vm._s(_vm.appendIcon) + " "),
                          ]),
                        ],
                        1
                      ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }